import { Link } from "react-router-dom";
import { ChevronRight, Home as HomeIcon } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
    // items: [{ label, to }]
    const ldItems = [
        {
            "@type": "ListItem",
            position: 1,
            name: "Startseite",
            item: "https://alpen-reinigung.at/",
        },
        ...items.map((it, idx) => ({
            "@type": "ListItem",
            position: idx + 2,
            name: it.label,
            item: it.to ? `https://alpen-reinigung.at${it.to}` : undefined,
        })),
    ];
    const ld = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: ldItems,
    };

    return (
        <nav
            aria-label="Breadcrumb"
            className="text-xs sm:text-sm text-[#8FA0B8]"
            data-testid="breadcrumbs"
        >
            <ol className="flex items-center flex-wrap gap-1.5">
                <li>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1 hover:text-white transition-colors"
                    >
                        <HomeIcon className="h-3.5 w-3.5" />
                        <span className="sr-only sm:not-sr-only">Startseite</span>
                    </Link>
                </li>
                {items.map((it, idx) => {
                    const isLast = idx === items.length - 1;
                    return (
                        <li key={`${it.label}-${idx}`} className="inline-flex items-center gap-1.5">
                            <ChevronRight className="h-3.5 w-3.5 text-[#3a4658]" />
                            {isLast || !it.to ? (
                                <span className="text-[#C9D3E1]">{it.label}</span>
                            ) : (
                                <Link
                                    to={it.to}
                                    className="hover:text-white transition-colors"
                                >
                                    {it.label}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }}
            />
        </nav>
    );
}
